"use client";

import { Link } from '@/compat/react-router-dom';
import { useSiteGlobals } from '@/states';

export default function CookieConsentBanner() {
  const { cookieConsent, setCookieConsentDecision } = useSiteGlobals();

  if (!cookieConsent?.initialized || cookieConsent.decision !== 'unset') {
    return null;
  }

  return (
    <aside className="cookie-consent-banner" role="dialog" aria-live="polite" aria-label="Cookie preferences">
      <div className="cookie-consent-banner__content">
        <p className="cookie-consent-banner__text mb-0">
          We use essential cookies for core functionality and optional analytics cookies to improve
          the site. See our{' '}
          <Link to="/cookie-policy" className="cookie-consent-banner__link">
            Cookie Policy
          </Link>
          .
        </p>
        <div className="cookie-consent-banner__actions">
          <button
            type="button"
            className="btn btn-sm btn-outline-light"
            onClick={() => setCookieConsentDecision({ analytics: false })}
          >
            Reject non-essential
          </button>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => setCookieConsentDecision({ analytics: true })}
          >
            Accept all
          </button>
        </div>
      </div>
    </aside>
  );
}
